var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PickupGrabbableMessage, MoveGrabbableMessage, ReleaseGrabbableMessage } from "@messages/interaction/InteractionMessages";
import { NewModule, MessageHandler } from "@modules/module";
import { peerService } from "@modules/multiplayer";
import { computeLocalMatrixFromWorldTransformComponents, modelPool } from "@modules/model";
/**
 * Tracks which models are currently grabbed so only the owning user can apply movement updates while a grab interaction is active.
 *
 * Messages:
 * - `PickupGrabbableMessage` - Starts tracking a synchronized grab on a model.
 * - `MoveGrabbableMessage` - Updates the transform of a grabbed model while the local user owns the grab.
 * - `ReleaseGrabbableMessage` - Ends the grab tracking for a model.
 */
export class ModelDragSyncModule extends NewModule {
    constructor() {
        super("ModelDragSyncModule");
        this.draggedModels = new Map();
    }
    handlePickupGrabbableMessage(msg, meta) {
        var _a;
        if (this.draggedModels.has(msg.uid))
            return;
        const clientId = (_a = meta.clientId) !== null && _a !== void 0 ? _a : peerService.clientId;
        this.draggedModels.set(msg.uid, { clientId });
    }
    handleMoveGrabbableMessage(msg, meta) {
        var _a;
        const info = this.draggedModels.get(msg.uid);
        if (info === undefined || info.clientId !== ((_a = meta.clientId) !== null && _a !== void 0 ? _a : peerService.clientId))
            return;
        const model = modelPool.getModel(msg.uid);
        if (model === undefined)
            return;
        const localTransform = computeLocalMatrixFromWorldTransformComponents(model, msg.position, msg.orientation, msg.scale);
        model.setTransform(localTransform);
        model.flushMessages();
    }
    handleReleaseGrabbableMessage(msg) {
        this.draggedModels.delete(msg.uid);
    }
}
__decorate([
    MessageHandler(PickupGrabbableMessage)
], ModelDragSyncModule.prototype, "handlePickupGrabbableMessage", null);
__decorate([
    MessageHandler(MoveGrabbableMessage)
], ModelDragSyncModule.prototype, "handleMoveGrabbableMessage", null);
__decorate([
    MessageHandler(ReleaseGrabbableMessage)
], ModelDragSyncModule.prototype, "handleReleaseGrabbableMessage", null);
